import ApiService from '../ApiService'

const permissionService = {

    getPermissions(rolId) {
        return ApiService.get(`/permissions/${rolId}`)
    },

    savePermissions(data) {
        return ApiService.post(`/permissions`, data)
    }

}

export default permissionService